<div class="container table-page">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Third-Party Management'"
    [altColor]="false"
  >
  </aw-divider>

  <!-- Bar and table together, so the bar sits 8px above the table rather than a .container gap away. -->
  <div class="table-section">
    <app-table-action-bar>
      <app-aw-date-form
        [title]="'Filter by Date Created'"
        (dateSelected)="onDateSelected($event)"
        [required]="false"
      >
      </app-aw-date-form>

      @if (userPermissions['canCreate']) {
      <button
        type="button"
        class="table-action-bar__end"
        AwButton
        [buttonType]="'primary'"
        (click)="openAddThirdParty()"
      >
        Add Third Party
      </button>
      }
    </app-table-action-bar>

    <!-- Re-created across the phone breakpoint: aw-table reads its scroll mode once, on init. -->
    @for (mode of [isPhone() ? 'phone' : 'desktop']; track mode) {
      <aw-table
        [columnsDefinition]="columnsDefinition"
        [tableData]="tableData()"
        [tableHeight]="isPhone() ? '' : '100%'"
        [enableInfiniteScroll]="!isPhone()"
        [displayableRowsCount]="50"
        [enableStickyOptions]="enableStickyOptions()"
        [sortDisabled]="sortDisabled()"
      >
      </aw-table>
    }
    <aw-footer [resultsCount]="tableData().length"></aw-footer>
    <app-results-status [count]="tableData().length"></app-results-status>
  </div>

  <aw-dialog
    [visible]="openDeleteDialog"
    [dialogOptions]="dialogOptionsDelete"
    (primaryAction)="dialogFormDeleteHandler($event)"
    (secondaryAction)="dialogCloseHandler()"
    ariaLabel="Delete Third Party"
  >
  </aw-dialog>
</div>
